export default "__VITE_ASSET__YXxDcUMy__"